module.exports = __webpack_public_path__ + "img/user-down-01.9bfdc9dd.svg";